import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'ExpandableHtmlBlock',
  props: {
  content: {
    type: String,
    required: true,
  }, // HTML content to render
  limit: Number, // Character limit before truncation
  showToggle: {
    type: Boolean,
    default: true,
  },
},
  setup(__props) {

const props = __props



const expanded = ref(false)

const truncatedContent = computed(() => {
  if (expanded.value || !props.limit || props?.content?.length <= props.limit) {
    return props.content
  }
  return props.content?.slice(0, props.limit) + "..."
})

return { __sfc: true,props, expanded, truncatedContent }
}

})